import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import LoadingScreen from "../loadingScreenComp/LoadingScreen";
import {
	PolicyTypes,
	TabTypes,
	UserType,
	Organization,
	Department,
	Role,
	Policy,
} from "./OrganizationAddUserTypes";
import { InputGroupPropsTypes } from "../inputComp/InputGroupType";
import InputGroup from "../inputComp/InputGroup";
import {
	AddressIcon,
	CloseIcon,
	CountryIcon,
	DarkModeIcon,
	DepartmentIcon,
	EmailIcon,
	IconThemeClassic,
	IdIcon,
	LightModeIcon,
	MobileIcon,
	OrganizationIcon,
	PasswordIcon,
	RainbowIcon,
	RoleIcon,
	SearchIcon,
	UserIcon,
} from "../iconSet/IconSet";
import { SelectItemTypes } from "../../CommonTypes";
import axios from "axios";
import DataTable from "react-data-table-component";
import { customStyles } from "../popupComp/CustomDataTableStyles";
import TableNoData from "../tablePartComp/TableNoData";
import TableTitle from "../tablePartComp/TableTitle";
import OrganizationPolicyDataTable from "./OrganizationPolicyDataTable";
import { AccentColorTypes, ThemeEagleIType, ThemeModesEagleITypes, ThemeModesTypes } from "../settingsComp/SettingsTypes";
import { ThemeTypes } from "../../context/ContextTypes";
import DragDropUpload from "../inputComp/DragDropUpload";
import AlertDialog from "../popupComp/AlertDialog";
import { NewUserAreaTable } from "./NewUserAreaTable";

import loadLightIcon from '../../images/icons/load-light.gif'
import loadDarkIcon from '../../images/icons/load-dark.gif'
import { useTheme } from "../../context/ThemeContext";
import { useUserData } from "../../context/UserDataContext";

/* interface Policy {
	policy: string;
	value: string;
} */

const accentColorsBCBackoffice: AccentColorTypes[] = [
	{name: 'blue', color: 'rgb(2, 117, 216)'},
	{name: 'green', color: 'rgb(92, 184, 92)'},
	{name: 'cyan', color: 'rgb(91, 192, 222)'},
	{name: 'yellow', color: 'rgb(240, 173, 78)'},
	{name: 'black', color: 'rgb(41, 43, 44)'},
	{name: 'brown', color: 'rgb(196, 64, 64)'}
]

const themeModesBCBackoffice: ThemeModesTypes[] = [
	{name: 'light', icon: <LightModeIcon color='var(--color-text)' width='1.3rem' className='icon'/>},
	{name: 'dark', icon: <DarkModeIcon color='var(--color-text)' width='1rem' className='icon'/>},
	{name: 'colorful', icon: <RainbowIcon color='var(--color-text)' width='1.3rem' className='icon'/>}
]

const accentColorsEagleI: AccentColorTypes[] = [
	{name: 'blue', color: 'rgb(2, 117, 216)'},
	{name: 'green', color: 'rgb(92, 184, 92)'},
	{name: 'cyan', color: 'rgb(91, 192, 222)'},
	{name: 'yellow', color: 'rgb(240, 173, 78)'},
	{name: 'black', color: 'rgb(41, 43, 44)'},
	{name: 'brown', color: 'rgb(196, 64, 64)'}
]

const themeModesEagleI: ThemeModesEagleITypes[] = [
	{name: 'light', icon: <LightModeIcon color='var(--color-text)' width='1.3rem' className='icon'/>},
	{name: 'dark', icon: <DarkModeIcon color='var(--color-text)' width='1rem' className='icon'/>},
	{name: 'classic', icon: <IconThemeClassic color='var(--color-text)' width='1.3rem' className='icon'/>},
	{name: 'darkblue', icon: <RainbowIcon color='var(--color-text)' width='1.3rem' className='icon'/>},
]

const OrganizationAddUser = () => {
	// Loading screen
	const [isLoading, setIsLoading] = useState<boolean>(true);

	const { theme } = useTheme()

	const { roleType, policies } = useUserData()
	
	const [alertDialogState, setAlertDialogState] = useState(false);
	const [alertTitle, setAlertTitle] = useState('');
	const [alertDescription, setAlertDescription] = useState('');
	const [alertYesCallback, setAlertYesCallback] = useState<(() => void) | undefined>(undefined); // for Yes
	const [alertOkCallback, setAlertOkCallback] = useState<(() => void) | undefined>(undefined);  // for OK

	const showAlertDialog = (
	title: string,
	description: string,
	yesCallback?: () => void,
	okCallback?: () => void
	) => {
	setAlertTitle(title);
	setAlertDescription(description);
	setAlertYesCallback(() => yesCallback); // Will show Yes/Cancel if defined
	setAlertOkCallback(() => okCallback);   // Will trigger only on OK
	setAlertDialogState(true);
	};

	//User Details
	const [userDetails, setUserDetails] = useState<any>(null);

	// Tabs
	const tabs: string[] = ["basic_details", "themes", "policies"];
	const [selectedTab, setSelectedTab] = useState<TabTypes>("basic_details");

	const [isDataPickerOpen, setIsDataPickerOpen] = useState<boolean>(false);
	const [isDataPickerLoading, setIsDataPickerLoading] = useState<boolean>(true);

	const [isRoleSelectOpen, setIsRoleSelectOpen] = useState<boolean>(false);
  	const [themeColor, setThemeColor] = useState<String>("");

	const allUsers = useRef<UserType[]>([]);
	const [filteredUsersData, setFilteredUserData] = useState<UserType[]>([]);

	const [roleData, setRoleData] = useState<SelectItemTypes[]>([]);

	const [organizations, setOrganizations] = useState<Organization[]>([]);
	const [departments, setDepartments] = useState<Department[]>([]);

	const [roles, setRoles] = useState<Role[]>([]);
	const allRolesRef = useRef<Role[]>([])
	const [selectedRole, setSelectedRole] = useState<Role>()

	const [selectedOrg, setSelectedOrg] = useState<string>("");
	const [selectedDept, setSelectedDept] = useState<string>("");

	const [titleName, setTitleName] = useState<string>("setup user")

	const selectedAreaRef = useRef<string[]>([])
	const [selectedArea, setSelectedArea] = useState<string[]>([])

	const [isDataLoading, setIsDataLoading] = useState<boolean>(false);

	useEffect(() => {
		selectedAreaRef.current = selectedArea
		setForm(prevState => ({
			...prevState,
			specificAreas: selectedAreaRef.current
		}))
	}, [selectedArea])

	const BASE_URL = process.env.REACT_APP_BASE_URL

	useEffect(() => {
		const savedUser = sessionStorage.getItem("user");
		if (savedUser) {
			const parsedUser = JSON.parse(savedUser);
			setUserDetails(parsedUser);

			// Extract policies from the user data
			const userPolicies = parsedUser.policies
				.split(",")
				.map((p: string) => p.trim());
			setUserPolicies(userPolicies); // Add this state to your component
		}
	}, []);

	const [userPolicies, setUserPolicies] = useState<string[]>([]);

	const hasPolicy = (policyName: string): boolean => {
		return userPolicies.includes(policyName);
	};

	useEffect(() => {
		setIsLoading(true)
		const token = localStorage.getItem("access_token");
		//fetch("https://bos.beconx.live/api/v1/getallorganizations", {
		fetch(BASE_URL + "/identity_manager/api/v1/getallorganizations", {
			method: "GET",
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((data) => {
				//console.log("Fetched organizations JSON:", data);

				const formatted = data.map((org: any) => ({
					value: org.organizationid,
					name: org.organizationname,
				}));
				setOrganizations(formatted);
			})
			.catch((err) => console.error("Error fetching organizations:", err))
			.finally(() => {
				setIsLoading(false)
			})
	}, []);

	useEffect(() => {
		setIsLoading(true)
		const token = localStorage.getItem("access_token");
		if (selectedOrg) {
			//fetch(`https://bos.beconx.live/api/v1/getdepartmentsbyorgid?organizationId=${selectedOrg}`,
			fetch(BASE_URL + `/identity_manager/api/v1/getdepartmentsbyorgid?organizationId=${selectedOrg}`,
				{
					method: "GET",
					headers: {
						Authorization: `Bearer ${token}`,
						"Content-Type": "application/json",
					},
				}
			)
				.then((response) => {
					if (!response.ok) throw new Error("Failed to load departments");
					return response.json();
				})
				.then((data) => {
					//console.log("Fetched Departments JSON:", data);

					const formatted = data.map((dep: any) => ({
						value: dep.departmentid,
						name: dep.departmentname,
					}));
					setDepartments(formatted);
				})
				.catch((err) => console.error(err))
				.finally(() => {
					setIsLoading(false)
				})
			//setSelectedDept("");
		} else {
			setDepartments([]);
		}
	}, [selectedOrg]);

	useEffect(() => {
		setIsLoading(true)
		const token = localStorage.getItem("access_token");
		//fetch(`https://bos.beconx.live/api/v1/getallroles`, {
		fetch(BASE_URL + `/identity_manager/api/v1/getallroles`, {
			method: "GET",
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
		})
			.then((response) => {
				if (!response.ok) throw new Error("Failed to load roles");
				return response.json();
			})
			.then((data) => {
				//console.log("Fetched Role JSON:", data);
				let tempRoleData = []
				if (roleType === 'whole_country')
				{
					tempRoleData = data
				}
				else
				{
					tempRoleData = data.filter((role: any) => role.roleAreaSpecificity === roleType)
				}
				
				const formatted = tempRoleData.map((role: any) => ({
					value: role.roleid,
					name: role.rolename,
				}));
				allRolesRef.current = tempRoleData
				setRoles(formatted);
			})
			.catch((err) => console.error(err))
			.finally(() => {
				setIsLoading(false)
			})
	}, []);

	// Form fields
	const countryRef = useRef<HTMLInputElement | null>(null);
	const usernameRef = useRef<HTMLInputElement | null>(null);
	const firstNameRef = useRef<HTMLInputElement | null>(null);
	const lastNameRef = useRef<HTMLInputElement | null>(null);
	const addressRef = useRef<HTMLInputElement | null>(null);
	const mobileNumberRef = useRef<HTMLInputElement | null>(null);
	const organizationRef = useRef<HTMLSelectElement | null>(null);
	const departmentRef = useRef<HTMLSelectElement | null>(null);
	const roleRef = useRef<HTMLSelectElement | null>(null);
	const emailRef = useRef<HTMLInputElement | null>(null);
	const nicRef = useRef<HTMLInputElement | null>(null);
	const passwordRef = useRef<HTMLInputElement | null>(null);
	const confirmPasswordRef = useRef<HTMLInputElement | null>(null);

	// Check box values
	/* const mprMeghaRef = useRef<HTMLInputElement | null>(null);
	const mprVisuraRef = useRef<HTMLInputElement | null>(null);
	const mprVisuraDashboardRef = useRef<HTMLInputElement | null>(null);
	const mprBackOfficeSystemRef = useRef<HTMLInputElement | null>(null); */

	const productBconexBackofficeRef = useRef<HTMLInputElement | null>(null);
	const productBconexMobileRef = useRef<HTMLInputElement | null>(null);
	const productEagleIRef = useRef<HTMLInputElement | null>(null);

	const [themesBConexBackofficeAvailable, setThemesBConexBackofficeAvailable] = useState<ThemeModesTypes[]>(themeModesBCBackoffice)
	const [themesBConexBackoffice, setThemesBConexBackoffice] = useState<ThemeTypes>('colorful')
	const [accentColorBConexBackofficeAvailable, setAccentColorBConexBackofficeAvailable] = useState<AccentColorTypes[]>(accentColorsBCBackoffice)
	const [accentColorBConexBackoffice, setAccentColorBConexBackoffice] = useState<AccentColorTypes>({name: 'blue', color: 'rgb(2, 117, 216)'})

	const [themesEagleIAvailable, setThemesEagleIAvailable] = useState<ThemeModesEagleITypes[]>(themeModesEagleI)
	const [themesEagleI, setThemesEagleI] = useState<ThemeEagleIType>('dark')
	const [accentColorEagleIAvailable, setAccentColorEagleIAvailable] = useState<AccentColorTypes[]>(accentColorsEagleI)
	const [accentColorEagleI, setAccentColorEagleI] = useState<AccentColorTypes>({name: 'blue', color: 'rgb(2, 117, 216)'})

	const [file, setFile] = useState<File[]>([])

	const [refreshKey, setRefreshKey] = useState(0);

	// Policies
	/* const policiesData: Policy[] = [
		{ policy: "Policy A", value: "a" },
		{ policy: "Policy B", value: "b" },
		{ policy: "Policy C", value: "c" },
		{ policy: "Policy D", value: "d" },
	]; */

	const [policiesData, setPoliciesData] = useState<Policy[]>([]);

	// useEffect(() => {
	// 	const fetchPolicies = async () => {
	// 		setIsDataLoading(true)
	// 		try {
	// 			setIsLoading(true)
	// 			const token = localStorage.getItem("access_token");
	// 			if (!token) {
	// 				throw new Error("No authentication token found");
	// 			}

	// 			//const response = await fetch("https://bos.beconx.live/api/v1/getallpolicies",
	// 			const response = await fetch(BASE_URL + "/identity_manager/api/v1/getallpolicies",
	// 				{
	// 					method: "GET",
	// 					headers: {
	// 						Authorization: `Bearer ${token}`,
	// 						"Content-Type": "application/json",
	// 					},
	// 				}
	// 			);

	// 			if (!response.ok) {
	// 				throw new Error(`Failed to fetch policies: ${response.status}`);
	// 			}

	// 			const data: Policy[] = await response.json();
	// 			setPoliciesData(data);
	// 		} catch (err) {
	// 			console.error("Error fetching policies:", err);
	// 			// Optionally set error state here
	// 		}
	// 		finally{
	// 			//setIsLoading(false)
	// 			setIsDataLoading(false)
	// 		}
	// 	};

	// 	fetchPolicies();
	// }, []);

	useEffect(() => {
		const fetchPolicies = async () => {
			setIsDataLoading(true)
			try {
				setIsLoading(true)
				const token = localStorage.getItem("access_token");
				if (!token) {
					throw new Error("No authentication token found");
				}

				//const response = await fetch("https://bos.beconx.live/api/v1/getallpolicies",
				const response = await fetch(BASE_URL + "/identity_manager/api/v1/getallpoliciesbyuser",
					{
						method: "GET",
						headers: {
							Authorization: `Bearer ${token}`,
							"Content-Type": "application/json",
						},
					}
				);

				if (!response.ok) {
					throw new Error(`Failed to fetch policies: ${response.status}`);
				}

				const data: Policy[] = await response.json();
				setPoliciesData(data);
			} catch (err) {
				console.error("Error fetching policies:", err);
				// Optionally set error state here
			}
			finally {
				//setIsLoading(false)
				setIsDataLoading(false)
			}
		};

		fetchPolicies();
	}, []);

	const accessPrivileges = [
		/* { label: "megha", ref: mprMeghaRef, value: "megha" },
		{ label: "visura", ref: mprVisuraRef, value: "visura" },
		{
			label: "visura dashboard",
			ref: mprVisuraDashboardRef,
			value: "visura_dashboard",
		},
		{
			label: "back office system",
			ref: mprBackOfficeSystemRef,
			value: "back_office_system",
		}, */
		{ label: "BCONX backoffice", ref: productBconexBackofficeRef, value: "bconex_backoffice" },
		{ label: "UDHA mobile", ref: productBconexMobileRef, value: "bconex_mobile" },
		{ label: "Eagle-I", ref: productEagleIRef, value: "eagle-i" }
	];

	const [form, setForm] = useState<UserType>({
		country: "Sri Lanka",
		username: "",
		firstname: "",
		lastname: "",
		address: "",
		mobilenumber: "",
		organization: "",
		department: "",
		role: "",
		email: "",
		nic: "",
		password: "",
		policies: "",
		accessprivileges: "",
		thememodebconex: "colorful",
		themecolorbconex: "blue",
		thememodeeaglei: "dark",
		//policies: [] as string[],
		specificAreas: [],
		organizationName: '',
		departmentName: ''
	});

	const policiesCheckboxRef = useRef({
		policies: [] as string[],
	})
	/* const [policiesCheckbox, setPolisciesCheckbox] = useState({
		policies: [] as string[],
	}); */
	const [accessPrivilegesCheckbox, setAccessPrivilegesCheckbox] = useState({
		accessprivileges: [] as string[],
	});

	const [isUpdate, setIsUpdate] = useState(false);

	const handleChange = (e: any) => {
		const { name, value } = e.target;

		if (e.target.name === 'role')
		{
			console.log("ROLE CHANGE")
			const data: Role = allRolesRef.current.find(item => item.roleid === value)!
			setSelectedRole(data)
		}

		// Clone current form state
		let updatedForm = { ...form, [name]: value };

		// If organization is changed, reset dependent fields
		if (name === "organization") {
			setSelectedOrg(value);
			updatedForm = {
				...updatedForm,
				department: "", // clear department
				role: "", // clear role
			};
			setSelectedDept(""); // also reset department state
		}

		setForm(updatedForm);
	};

	const handleSelectedRowsChange = (selected: Policy[]) => {
		
		const selectedPolicies = selected.map(
			(row: Policy) => row.policy
		);

		// Prevent unnecessary state updates
		const isSame =
			selectedPolicies.length === policiesCheckboxRef.current.policies.length &&
			selectedPolicies.every((p: any) => policiesCheckboxRef.current.policies.includes(p));

		if (!isSame) {
			policiesCheckboxRef.current = ({ policies: selectedPolicies });
		}
		form.policies = policiesCheckboxRef.current.policies.toString();
	};

	const [filterPolicyText, setFilterPolicyText] = useState("");

	const filteredPolicies = policiesData.filter((p) =>
		p.policy.toLowerCase().includes(filterPolicyText.toLowerCase())
	);

	// const filteredPolicies = policiesData.filter((p) => {
	// 	const normalizedPolicyName = p.policy
	// 	  .toUpperCase()
	// 	  .replace(/\s+/g, '_')
	// 	  .replace(/--?/g, '_'); // Handle dashes like " - " → "_"
	  
	// 	// Extract resource from "resource:action" format
	// 	const normalizedValue = p.value
	// 	  ?.toUpperCase()
	// 	  .split(':')[0]; // "weather:manage" → "WEATHER"
	  
	// 	return policies
	// 	  .filter(Boolean)
	// 	  .some((userPolicy) =>
	// 		userPolicy === normalizedPolicyName ||
	// 		userPolicy === normalizedValue
	// 	  );
	// });

	//handleCheckboxChange of Access Privileges
	const handleCheckboxChangeAccessPrivileges = (
		e: React.ChangeEvent<HTMLInputElement>
	) => {
		const { value, checked } = e.target;
		const updatedAccessPrivileges = checked
			? [...accessPrivilegesCheckbox.accessprivileges, value]
			: accessPrivilegesCheckbox.accessprivileges.filter((ap) => ap !== value);

		setAccessPrivilegesCheckbox({ accessprivileges: updatedAccessPrivileges });
		setForm((prev) => ({
			...prev,
			accessprivileges: updatedAccessPrivileges.join(","),
		}));
	};

	const handleBlur = async () => {
		const token = localStorage.getItem("access_token");

		if (form.username.trim() !== "") {
			try {
				const res = await axios.get(
					BASE_URL + `/identity_manager/api/v1/getuser/${form.username}`,
					{
						headers: {
							Authorization: `Bearer ${token}`,
						},
					}
				);

				// ✅ Handle "user not found" response from Spring Boot
				if (res.data?.status === "not_found") {
					console.log(res.data.message); // "User not found"
					setForm({
						country: "Maldives",
						username: form.username,
						firstname: "",
						lastname: "",
						address: "",
						mobilenumber: "",
						organization: "",
						department: "",
						role: "",
						email: "",
						nic: "",
						password: "",
						policies: "",
						accessprivileges: "",
						thememodebconex: "colorful",
						themecolorbconex: "blue",
						thememodeeaglei: "dark",
						specificAreas: [],
						organizationName: '',
						departmentName: ''
					});								
					policiesCheckboxRef.current = { policies: [] };
					setAccessPrivilegesCheckbox({ accessprivileges: [] });
					setIsUpdate(false);
					return;
				}

				const fetchedForm = res.data;

				// ✅ Parse policy and privileges
				const policyArray = fetchedForm.policies
					? fetchedForm.policies.split(",").map((p: string) => p.trim())
					: [];

				const privilegesArray = fetchedForm.accessprivileges
					? fetchedForm.accessprivileges.split(",").map((p: string) => p.trim())
					: [];

				const themeModeBconexValue = fetchedForm.thememodebconex;
				const themeColorBconexValue = fetchedForm.themecolorbconex;
				const themeColorEagleIVlaue = fetchedForm.thememodeeaglei;

				const matchedThemeColorBconex = accentColorsEagleI.find(
					(item) => item.name === themeColorBconexValue
				);

				setForm({
					...fetchedForm,
				});
				setSelectedOrg(fetchedForm.organization);
				policiesCheckboxRef.current = { policies: policyArray };
				setAccessPrivilegesCheckbox({ accessprivileges: privilegesArray });

				// Theme settings
				const defaultTheme: ThemeTypes = "dark";
				setThemesBConexBackoffice((themeModeBconexValue ?? defaultTheme) as ThemeTypes);
				if (matchedThemeColorBconex) {
					setAccentColorBConexBackoffice(matchedThemeColorBconex);
				} else {
					setAccentColorBConexBackoffice({
						name: "blue",
						color: "rgb(2, 117, 216)",
					});
				}
				setThemesEagleI((themeColorEagleIVlaue ?? defaultTheme) as ThemeEagleIType);

				setIsUpdate(true);
			} catch (error: any) {
				// ✅ Handle admin role rejection (400 Bad Request)
				if (error.response.data?.message === "Please use another username") {

					showAlertDialog("Username Error","Please use another username",undefined,() => window.location.reload());
					console.error("Server validation error:");

				} else {
					console.error("Unexpected error:", error);
				}

				setForm({
					country: "Maldives",
					username: form.username,
					firstname: "",
					lastname: "",
					address: "",
					mobilenumber: "",
					organization: "",
					department: "",
					role: "",
					email: "",
					nic: "",
					password: "",
					policies: "",
					accessprivileges: "",
					thememodebconex: "colorful",
					themecolorbconex: "blue",
					thememodeeaglei: "dark",
					specificAreas: [],
					organizationName: '',
					departmentName: ''
				});
				policiesCheckboxRef.current = { policies: [] };
				setAccessPrivilegesCheckbox({ accessprivileges: [] });
				setIsUpdate(false);
			}
		}
	};

	useEffect(() => {
		//console.log("Checkbox state updated:", policiesCheckbox.policies);
	}, [policiesCheckboxRef.current, accessPrivilegesCheckbox]);
	
	const formItems: InputGroupPropsTypes[] = [
		{
			type: "text",
			icon: <CountryIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Select country",
			label: "country",
			componentInputElement: countryRef,
			name: "country",
			required: true,
			disabled: true,
			value: "Maldives",
			onChange: handleChange,
		},
		{
			type: "text",
			icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter username",
			label: "username",
			componentInputElement: usernameRef,
			name: "username",
			value: form.username,
			required: true,
			//disabled: true,
			onChange: handleChange,
			onBlur: handleBlur,
			dataPicker: true,
			isDataPickerOpen: isDataPickerOpen,
			setIsDataPickerOpen: setIsDataPickerOpen,
		},
		{
			type: "text",
			icon: <UserIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter first name",
			label: "first name",
			name: "firstname",
			value: form.firstname,
			componentInputElement: firstNameRef,
			onChange: handleChange,
			required: true
		},
		{
			type: "text",
			icon: <UserIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter last name",
			label: "last name",
			name: "lastname",
			value: form.lastname,
			componentInputElement: lastNameRef,
			onChange: handleChange,
		},
		{
			type: "text",
			icon: <AddressIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter address",
			label: "address",
			name: "address",
			value: form.address,
			componentInputElement: addressRef,
			onChange: handleChange,
		},
		{
			type: "text",
			icon: <MobileIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter mobile number",
			label: "mobile number",
			name: "mobilenumber",
			value: form.mobilenumber,
			componentInputElement: mobileNumberRef,
			onChange: handleChange,
		},
		/* ...(hasPolicy("Organization Manage") ?[{
			type: "select",
			icon: <OrganizationIcon width="1.3rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			label: "organization",
			componentSelectElement: organizationRef,
			optionList: organizations,
			placeholder: "select organization",
			name: "organization",
			value: form.organization,
			//value: getNameFromValue(form.organization, organization),
			required: true,
			disabled: !hasPolicy("Organization Manage"),
			hidden: !hasPolicy("Organization Manage"),
			onChange: handleChange,
		}]:[]), */
		{
			type: "select" as const, // <-- Force TypeScript to treat this as a literal type
			icon: <OrganizationIcon width="1.3rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			label: "organization",
			componentSelectElement: organizationRef,
			optionList: organizations,
			placeholder: "select organization",
			name: "organization",
			value: form.organization,
			required: true,
			onChange: handleChange,
		},
		/* {
			type: "select",
			icon: <DepartmentIcon width="1.3rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			label: "department",
			componentSelectElement: departmentRef,
			optionList: departments,
			placeholder: "select department",
			name: "department",
			value: form.department,
			disabled: !hasPolicy(
				"Organization Manage"
			), // || !hasPolicy("Department Manage") ,
			required: true,
			onChange: handleChange,
		}, */
		{
			type: "select" as const,
			icon: <DepartmentIcon width="1.3rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			label: "department",
			componentSelectElement: departmentRef,
			optionList: departments,
			placeholder: "select department",
			name: "department",
			value: form.department,
			// disabled: !hasPolicy(
			// 	"Organization Manage"
			// ), // || !hasPolicy("Department Manage") ,
			required: true,
			onChange: handleChange,
		},
		/* {
			type: 'multi-selector',
			icon: <RoleIcon width="1.3rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			label: "select role",
			componentSelectElement: roleRef,
			required: true,
			optionList: selectRole,
			placeholder: "select role",
			value: form.role,
			name: "role",
			onChange: handleChange,
			multiData: roleData,
			onClick: handleRoleSelect
		}, */
		{
			type: "select",
			icon: <RoleIcon width="1.3rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			label: "select role",
			componentSelectElement: roleRef,
			required: true,
			optionList: roles,
			placeholder: "select role",
			value: form.role,
			name: "role",
			onChange: handleChange,
		},
		{
			type: "text",
			icon: <EmailIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter email",
			label: "email",
			name: "email",
			componentInputElement: emailRef,
			required: true,
			onChange: handleChange,
			value: form.email,
		},
		{
			type: "text",
			icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter NIC number",
			label: "NIC number",
			name: "nic",
			componentInputElement: nicRef,
			value: form.nic,
			//required: true,
			onChange: handleChange,
		},
		{
			type: "password",
			icon: <PasswordIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter Password",
			label: "password",
			name: "password",
			value: form.password,
			componentInputElement: passwordRef,
			required: true,
			onChange: handleChange,
			disabled: isUpdate ? true : false,
		},
		{
			type: "password",
			icon: <PasswordIcon width="1.5rem" color="var(--color-main-white)" />,
			color: "var(--color-accent-bg)",
			placeholder: "Enter Confirm Password",
			label: "confirm password",
			name: "confirm_password",
			componentInputElement: confirmPasswordRef,
			required: true,
			//onChange: handleChange
			disabled: isUpdate ? true : false,
		},
	];

	const handleAddUser = async () => {
		setIsLoading(true);
	  
		try {
			const token = localStorage.getItem("access_token");
		
			const response = await fetch(
				BASE_URL + "/identity_manager/api/v1/bconexadduser",
				{
				method: "POST",
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify(form),
				}
			);
		
			// 🔹 Read body ONLY ONCE
			const contentType = response.headers.get("content-type");
			let data: any = null;
		
			if (contentType && contentType.includes("application/json")) {
				data = await response.json();
			} else {
				data = await response.text();
			}
		
			// 🔹 Handle success
			if (response.ok) {
				if (data?.message === "User Already Exits") {
				setIsUpdate(false);
				showAlertDialog("User Exists", "User already exists! user was not added.");
				return;
				}
		
				if (data?.message === "Email Already Exits") {
				setIsUpdate(false);
				showAlertDialog("Email Exists", "Email already exists! user was not added.");
				return;
				}
		
				// ✅ Success
				setIsUpdate(false);
		
				showAlertDialog(
				isUpdate ? "Success" : "Created",
				isUpdate ? "✅ User updated." : "✅ User created.",
				undefined,
				() => window.location.reload()
				);
		
				setForm({
				country: "Maldives",
				username: "",
				firstname: "",
				lastname: "",
				address: "",
				mobilenumber: "",
				organization: "",
				department: "",
				role: "",
				email: "",
				nic: "",
				password: "",
				policies: "",
				accessprivileges: "",
				thememodebconex: "colorful",
				themecolorbconex: "blue",
				thememodeeaglei: "dark",
				specificAreas: [],
				organizationName: '',
				departmentName: ''
				});
		
				policiesCheckboxRef.current = { policies: [] };
				setAccessPrivilegesCheckbox({ accessprivileges: [] });
				setRefreshKey((prev) => prev + 1);
		
				return;
			}
	  
		  // 🔹 Handle specific errors
		  if (response.status === 409) {
			showAlertDialog("Email Exists", "Email already exists! user was not added.");
			return;
		  }
	  
		  // 🔹 Other errors
		  console.log("User adding failed:", data);
		  setIsUpdate(false);
	  
		} catch (error) {
		  console.error("Unexpected error:", error);
		  showAlertDialog("Error", "Something went wrong while adding the user.");
		} finally {
		  setIsLoading(false);
		}
	};

	const handleDeleteUser = async () => {
		const token = localStorage.getItem("access_token");
		if (!token) {
      		showAlertDialog("Unauthorized", "Missing access token.");
			return;
		}

		try {
			setIsLoading(true)
			//const response = await fetch(`https://bos.beconx.live/api/v1/delete/${form.username}`,
			const response = await fetch(BASE_URL + `/identity_manager/api/v1/delete/${form.username}`,
				{
					method: "DELETE",
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);

			if (response.ok) {
				const resultText = await response.text(); // assuming plain string response like "User deleted successfully"
				showAlertDialog("Deleted", resultText,undefined,() => window.location.reload())
				setForm({
					country: "Sri Lanka",
					username: "",
					firstname: "",
					lastname: "",
					address: "",
					mobilenumber: "",
					organization: "",
					department: "",
					role: "",
					email: "",
					nic: "",
					password: "",
					policies: "",
					accessprivileges: "",
					thememodebconex: "colorful",
					themecolorbconex: "blue",
					thememodeeaglei: "dark",
					specificAreas: [],
					organizationName: '',
					departmentName: ''
				});
				policiesCheckboxRef.current = ({ policies: [] });
				setAccessPrivilegesCheckbox({ accessprivileges: [] });
				setIsUpdate(false);
			} else {
				const contentType = response.headers.get("content-type");
				if (contentType && contentType.includes("application/json")) {
					const error = await response.json();
					console.log(error.message || "Error deleting user");
				} else {
					const errorText = await response.text();
					console.log(errorText);
				}
			}
		} catch (err) {
			console.error("Delete failed", err);
			console.log("An error occurred during deletion");
		}
		finally{
			setIsLoading(false)
		}
	};

	// Handle create user next button click
	const handleCreateUserNextClick = () => {
		//const country = validateField(countryRef);
		//const username = validateField(usernameRef);
		// const nic = validateField(nicNumberRef);
		const password = passwordRef.current?.value;
		const confirmPassword = confirmPasswordRef.current?.value;
		//console.log(password)
		//console.log(confirmPassword)
		if (password != confirmPassword) {
			showAlertDialog("Validation Error", "Passwords do not match!");
			return;
		}
		console.log(password);
		console.log(confirmPassword);
		//handleAddUser();
		//if (country && username && nic) {
		setSelectedTab("policies");
		//}
	};

	// Handle tab click
	const handleTabClick = (tab: string) => {
		setSelectedTab(tab as TabTypes)
	};

	// Handle polices back button click
	const handlePoliceBackClick = () => {
		setSelectedTab("basic_details");
	};

	// Handle polices finish button click
	const handlePolicesFinishClick = () => {
		// console.log("Backoffice theme: ", themeModesBCBackoffice)
		// console.log("Backoffice accent: ", accentColorBConexBackoffice)
		// console.log("-------------------------------------------")
		// console.log("Eagle-I theme: ", themeModesEagleI)
		// console.log("Eagle-I accent: ", accentColorEagleI)
		// console.log("-------------------------------------------")
		// console.log("profile pic: ", file)
		// console.log("-------------------------------------------")
		// console.log("polices: ", policiesCheckboxRef.current)
		handleAddUser();
	};

	useEffect(() => {
		if (countryRef.current && usernameRef.current) {
			countryRef.current.value = "Maldives";
			//usernameRef.current.value = 'user_1'
		}
		setForm((prevForm) => ({
			...prevForm,
			country: "Maldives",
		}));
	}, []);

	// existing data change handle
	const handleChangeExistingDataSearch = (
		event: ChangeEvent<HTMLInputElement>
	): void => {
		if (event.target.value === "") {
			setFilteredUserData(allUsers.current);
		} else {
			setFilteredUserData(
				allUsers.current.filter((item) =>
					item.firstname.toLowerCase().includes(event.target.value.toLowerCase()) ||
					item.department.toLowerCase().includes(event.target.value.toLowerCase()) ||
					item.organization.toLowerCase().includes(event.target.value.toLowerCase())
				)
			);
		}
	};

	useEffect(() => {
		
	}, [filteredUsersData])

	// Handle clicking filtered item
	const handleClickFilteredOrganization = (user: UserType): void => {
		//console.log("CLICKED -> ", user)
		if (
			countryRef.current &&
			usernameRef.current &&
			firstNameRef.current &&
			lastNameRef.current &&
			addressRef.current &&
			mobileNumberRef.current &&
			organizationRef.current &&
			departmentRef.current &&
			roleRef.current &&
			emailRef.current &&
			nicRef.current &&
			passwordRef.current &&
			selectedAreaRef.current
		) {
			countryRef.current.value = user.country;
			usernameRef.current.value = user.username.toString();
			firstNameRef.current.value = user.firstname;
			lastNameRef.current.value = user.lastname;
			addressRef.current.value = user.address;
			mobileNumberRef.current.value = user.mobilenumber;
			organizationRef.current.value = user.organization;
			departmentRef.current.value = user.department;
			roleRef.current.value = user.role;
			emailRef.current.value = user.email;
			nicRef.current.value = user.nic;
			
			//passwordRef.current.value = user.password.toString()
			setSelectedArea(user.specificAreas !== null ? user.specificAreas : [])
			setTitleName("Update user")
		}

		const policyArray = user.policies
			? user.policies.split(",").map((p: string) => p.trim())
			: [];
		const privilegesArray = user.accessprivileges
			? user.accessprivileges.split(",").map((p: string) => p.trim())
			: [];

			const themeModeBconexValue = user.thememodebconex;
    		const themeColorBconexValue = user.themecolorbconex;
			const themeColorEagleIValue = user.thememodeeaglei;
			const matchedThemeColorBconex = accentColorsEagleI.find(
			(item) => item.name === themeColorBconexValue
			);
		// Update form state
		setForm({
			country: user.country,
			username: user.username,
			firstname: user.firstname,
			lastname: user.lastname,
			address: user.address,
			mobilenumber: user.mobilenumber,
			organization: user.organization,
			department: user.department,
			role: user.role,
			email: user.email,
			nic: user.nic,
			//password: user.password.toString(),
			policies: user.policies,
			accessprivileges: user.accessprivileges,
			thememodebconex: user.thememodebconex,
			themecolorbconex: user.themecolorbconex,
			thememodeeaglei: user.thememodeeaglei,
			specificAreas: selectedArea,
			organizationName: '',
			departmentName: ''
		})
		
		const data: Role = allRolesRef.current.find(item => item.roleid === user.role)!
		setSelectedRole(data)

		setSelectedArea(user.specificAreas)

		setSelectedOrg(user.organization)
		policiesCheckboxRef.current = ({ policies: policyArray })
		setAccessPrivilegesCheckbox({ accessprivileges: privilegesArray })
		const defaultTheme: ThemeTypes = "dark";
        setThemesBConexBackoffice((themeModeBconexValue ?? defaultTheme) as ThemeTypes)
		if (matchedThemeColorBconex) 
		{
			//console.log("Parsed policy array:", matchedThemeColorBconex)
			setAccentColorBConexBackoffice(matchedThemeColorBconex)
		} 
		else
		{
			setAccentColorBConexBackoffice({
				name: "blue",
				color: "rgb(2, 117, 216)",
			})
		}
		setThemesEagleI((themeColorEagleIValue ?? defaultTheme) as ThemeEagleIType)
		setIsDataPickerOpen(false)
		setIsUpdate(true)
	};

	// Get all available organization
	const getAllUsers = () => {
		setIsDataPickerLoading(true)
		const token = localStorage.getItem("access_token")
		//fetch("https://bos.beconx.live/api/v1/getallusers", {
		fetch(BASE_URL + "/identity_manager/api/v1/getallusers", {
			method: "GET",
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((data) => {
				allUsers.current = data;
				setFilteredUserData(data);
				//console.log(data)
			})
			.catch((err) => console.error("Error fetching roles:", err))
			.finally(() => {
				setIsDataPickerLoading(false)
			})
	};

	// Load data
	useEffect(() => {
		getAllUsers();
	}, [isUpdate, refreshKey]);

	// Calculate field count
	const sideFieldCount = (totalField: number): number => {
		if (totalField > 0) {
			const value = totalField % 2

			if (value === 0){
				return totalField / 2
			} else {
				return (totalField + 1) /2
			}
		} else {
			return totalField
		}
	}

	// Reset password
	/* const resetPassword = () => {
		
	} */

	// Handle theme change button click
	/* const handleThemeChangeClick = (type: ThemeTypes | ThemeEagleIType, product: "bc_backoffice" | "eagle-i") => {
		switch (product){
			case 'bc_backoffice':
				setThemesBConexBackoffice(type as ThemeTypes)
				break
			case 'eagle-i':
				setThemesEagleI(type as ThemeEagleIType)
				break
		}
	} */

		const handleThemeChangeClick = ( type: ThemeTypes | ThemeEagleIType, product: "bc_backoffice" | "eagle-i" ) => {
			switch (product) 
			{
				case "bc_backoffice":
					setThemesBConexBackoffice(type as ThemeTypes)
					const themeModeBconexValue = type.toString()
					setForm((prevForm) => ({
						...prevForm,
						thememodebconex: themeModeBconexValue,
					}))
					break
				case "eagle-i":
					setThemesEagleI(type as ThemeEagleIType);
					const themeModeEagleIValue = type.toString()
					setForm((prevForm) => ({
						...prevForm,
						thememodeeaglei: themeModeEagleIValue,
					}))
					break
			}
		}

	/* const handleAccentColorClick = (type: AccentColorTypes, product: "bc_backoffice" | "eagle-i") => {
		switch (product){
			case 'bc_backoffice':
				setAccentColorBConexBackoffice(type)
				break
			case 'eagle-i':
				setAccentColorEagleI(type)
				break
		}
	} */

	const handleAccentColorClick = (type: AccentColorTypes, product: "bc_backoffice" | "eagle-i" ) => {
		switch (product) 
		{
			case "bc_backoffice":
				setAccentColorBConexBackoffice(type);
				break;
			case "eagle-i":
				setAccentColorEagleI(type);
				break;
		}

		const themeColorValue = type.name.toString();
		setThemeColor(themeColorValue);

		setForm((prevForm) => ({
			...prevForm,
			themecolorbconex: themeColorValue,
		}))
	}

	useEffect(() => { }, [selectedRole])

	// useEffect(() => {
	// 	console.log("SELECT ROLE:", selectedArea)
	// }, [selectedArea])

	return (
		<div className={`container-wrapper`}>
			<span className={`title`}>{titleName}</span>
			<div className="tab-area">
				{tabs.map((tab, index) => (
					<span key={index} style={{ borderStyle: selectedTab === tab ? "solid" : "none" }} onClick={() => handleTabClick(tab)}>
						{tab.replace(/_/g, " ")}
					</span>
				))}
			</div>
			{/* Back office system -> add user -> create user */}
			<div style={{ display: selectedTab === "basic_details" ? "block" : "none", width: "100%", height: "100%" }}>
				<div className={`add-organization-user`}>
					<div className={`grid-layout-add-organization-user`}>
						<div className={`left-side`}>
							{formItems.slice(0, sideFieldCount(formItems.length)).map((field, index) => (
								isUpdate ? (
									(field.name === 'password' || field.name === 'confirm_password') ? (
										<InputGroup key={index} {...{...field, notVisible: true}} />
									) : <InputGroup key={index} {...field} />
								) : (
									<InputGroup key={index} {...field} />
								)
							))}
						</div>

						<div className={`right-side`}>
							{formItems.slice(sideFieldCount(formItems.length)).map((field, index) => (
								isUpdate ? (
									(field.name === 'password' || field.name === 'confirm_password') ? (
										<InputGroup key={index} {...{...field, notVisible: true}} />
									) : <InputGroup key={index} {...field} />
								) : (
									<InputGroup key={index} {...field} />
								)
							))}
							{isUpdate && (
								<div className={`button-wrapper`} style={{ gridArea: "button" }}>
									<div className={`left-side`}></div>
									<div className={`right-side`}>
										{/* <button className={`button-normal`} onClick={(e) => resetPassword()}>Reset password</button> */}
									</div>
								</div>
							)}
						</div>

						<div className={`checkbox-wrapper`}>
							<div className={`checkbox-container`}>
								<span className={`title`}>products</span>
								<div className={"wrapper"}>
									{/* <div className={`item`}>
										<input
											type="checkbox"
											name="accessprivileges"
											id="ur_checkbox_megha"
											ref={mprMeghaRef}
										/>
										<label htmlFor="ur_checkbox_megha">megha</label>
									</div>
									<div className={`item`}>
										<input
											type="checkbox"
											name=""
											id="ur_checkbox_visura"
											ref={mprVisuraRef}
										/>
										<label htmlFor="ur_checkbox_visura">visura</label>
									</div>
									<div className={`item`}>
										<input
											type="checkbox"
											name=""
											id="ur_checkbox_visura_dashboard"
											ref={mprVisuraDashboardRef}
										/>
										<label htmlFor="ur_checkbox_visura_dashboard">
											visura dashboard
										</label>
									</div>
									<div className={`item`}>
										<input
											type="checkbox"
											name=""
											id="ur_checkbox_back_office_system"
											ref={mprBackOfficeSystemRef}
										/>
										<label htmlFor="ur_checkbox_back_office_system">
											back office system
										</label>
									</div> */}
									{accessPrivileges.map((priv, index) => (
										<div key={index} className="item">
											<input
												type="checkbox"
												name="accessprivileges"
												id={`ur_checkbox_${priv.value}`}
												ref={priv.ref}
												value={priv.value}
												checked={accessPrivilegesCheckbox.accessprivileges.includes(
													priv.value
												)}
												onChange={handleCheckboxChangeAccessPrivileges}
											/>
											<label htmlFor={`ur_checkbox_${priv.value}`}>
												{priv.label}
											</label>
										</div>
									))}
								</div>
							</div>
						</div>

						<div className={`button-wrapper`} style={{ gridArea: "button" }}>
							<div className={`left-side`}></div>
							<div className={`right-side`}>
								<button className={`button-normal`} onClick={() => setSelectedTab('themes')}>next</button>
							</div>
						</div>
						{isDataPickerOpen && (
							<div className="data-picker-table-wrapper">
								<div className="data-picker-table-container">
									<div className="search-wrapper">
										<input type="text" placeholder="Search user" onChange={(e) => handleChangeExistingDataSearch(e)} />
										<div className="search-icon">
											<SearchIcon width="1rem" color="var(--color-main-white)" />
										</div>
										<div className="close-icon" onClick={(e) => setIsDataPickerOpen(false)} >
											<CloseIcon width="1.5rem" color="var(--color-text)" />
										</div>
									</div>
									<div className="row header">
										{/* <span style={{ width: '33%' }}>Country</span> */}
										<span style={{ width: '33%' }}>First Name</span>
										<span style={{ width: '33%' }}>Department</span>
										<span style={{ width: '33%' }}>Organization</span>
									</div>
									
									{isDataPickerLoading ? (
										<div className="searching-data">
											<img src={theme === 'dark' ? loadDarkIcon : theme === 'light' ? loadLightIcon : theme === 'colorful' ? loadLightIcon : ''} alt="" />
											<span>Searching user data...</span>
										</div>
									) : (
										<div className="data-wrapper">
											{filteredUsersData.map((user, index) => (
												<div
													key={index}
													className="row"
													onClick={(e) => handleClickFilteredOrganization(user)}
												>
													{/* <span style={{ width: '33%', textAlign: 'left' }}>{user.country}</span> */}
													<span style={{ width: '33%', textAlign: 'left' }}>{user.firstname}</span>
													<span style={{ width: '33%', textAlign: 'left' }}>{user.departmentName}</span>
													<span style={{ width: '33%', textAlign: 'left' }}>{user.organizationName}</span>
												</div>
											))}
										</div>
									)}
									
								</div>
							</div>
						)}

						{/* {isRoleSelectOpen && (
						<div className="data-picker-table-wrapper">
							<div className="data-picker-table-container">
								<span className="role-title">select roles <div onClick={(e) => setIsRoleSelectOpen(false)}><CloseIcon width="1rem" color="var(--color-text)"/></div></span>
								<div className="role-data-wrapper">
									{selectRole.map((data, index) => (
										<div key={index} className="role-data-check-container">
											<input type="checkbox" name={data.value} id="bo-add-user-role-1" onChange={(e) => handleChangeRoleSelect(e)}/>
											<label htmlFor="bo-add-user-role-1">{data.name}</label>
										</div>
									))}
								</div>
							</div>
						</div>
					)} */}
					</div>
				</div>
			</div>

			{/* Back office system -> add user -> profile */}
			<div style={{ display: selectedTab === 'themes' ? "block" : "none", width: "100%", height: "100%" }}>
				<div className={`add-organization-user`}>
					<div className={`layout-user-profile`}>
						<div className={`drag-drop-uploader`}>
							<DragDropUpload label="Choose Profile Picture" files={file} setFile={setFile}/>
						</div>
						{productBconexBackofficeRef.current?.checked && (
							<div className={`theme-setting-wrapper`}>
								<div className={`setting-container theme-wrapper`}>
									<div className={`title`}>
										<span>BConex Backoffice themes</span>
									</div>
									<div className={`left`}>
										<span className={`left-title`}>select theme mode</span>
										<div className={`theme-mode-wrapper`}>
											{themesBConexBackofficeAvailable.map((themes, index) => (
												<div key={index} className={`data-container`}>
													<div onClick={() => handleThemeChangeClick(themes.name, 'bc_backoffice')} style={{borderStyle: themesBConexBackoffice === themes.name ? 'solid' : 'none'}}>
														{themes.icon}
													</div>
													<span>{themes.name.replace("_", " ")}</span>
												</div>
											))}
										</div>
									</div>
									<div className={`right`}>
										<span className={`right-title`}>select accent color</span>
										<div className={`accent-color-wrapper`}>
											{accentColorBConexBackofficeAvailable.map((color, index) => (
												<div key={index} className={`data-container`}>
													<div className={`color-box`} style={{backgroundColor: color.color, borderStyle: color.name === accentColorBConexBackoffice?.name ? 'solid' : 'none'}} onClick={(e) => handleAccentColorClick(color, 'bc_backoffice')}></div>
													<span>{color.name.replace("_", " ")}</span>
												</div>
											))}
										</div>
									</div>
								</div>
							</div>
						)}
						{productEagleIRef.current?.checked && (
							<div className={`theme-setting-wrapper`}>
								<div className={`setting-container theme-wrapper`}>
									<div className={`title`}>
										<span>Eagle-I themes</span>
									</div>
									<div className={`left`}>
										<span className={`left-title`}>select theme mode</span>
										<div className={`theme-mode-wrapper`}>
											{themesEagleIAvailable.map((themes, index) => (
												<div key={index} className={`data-container`}>
													<div onClick={() => handleThemeChangeClick(themes.name, 'eagle-i')} style={{borderStyle: themesEagleI === themes.name ? 'solid' : 'none'}}>
														{themes.icon}
													</div>
													<span>{themes.name.replace("_", " ")}</span>
												</div>
											))}
										</div>
									</div>
									<div className={`right`}>
										
									</div>
								</div>
							</div>
						)}
					</div>
					<div className={`button-wrapper`} style={{ gridArea: "button" }}>
						<div className={`left-side`}>
							<button className={`button-normal`} onClick={(e) => setSelectedTab("basic_details")}>back</button>
						</div>
						<div className={`right-side`}>
							<button className={`button-normal`} onClick={(e) => setSelectedTab("policies")}>next</button>
						</div>
					</div>
				</div>
			</div>

			{/* Back office system -> add user -> polices */}
			<div style={{ display: selectedTab === "policies" ? "block" : "none", width: "100%", height: "100%" }}>
				<div className={`add-organization-user`}>
					<div className={`grid-layout-polices`}>
						<div className="policy-table-container">
							<OrganizationPolicyDataTable data={filteredPolicies} handleSelectRow={handleSelectedRowsChange} selectedPolicies={policiesCheckboxRef.current.policies} isDataLoading={isDataLoading}/>
							{/* <input
								className="search"
								type="text"
								placeholder="Search policies..."
								value={filterPolicyText}
								onChange={(e) => setFilterPolicyText(e.target.value)}
							/>
							<DataTable
								title={<TableTitle title="select polices"/>}
								columns={columns}
								data={filteredPolicies}
								selectableRows
								onSelectedRowsChange={handleSelectedRowsChange}
								selectableRowSelected={(row: Policy) =>
									policiesCheckbox.policies.includes(row.policy)
								}
								customStyles={customStyles}
								pagination
								paginationPerPage={5}
								paginationRowsPerPageOptions={[5, 10, 15]}
								highlightOnHover
								pointerOnHover
								noDataComponent={<TableNoData />}
							/> */}
							{selectedRole && selectedRole.roleAreaSpecificity === 'area_specific' && (
								<NewUserAreaTable selectedRows={selectedArea} setSelectedRows={setSelectedArea}/>
							)}
							
						</div>
					</div>
					<div className={`button-wrapper`} style={{ gridArea: "button" }}>
						<div className={`left-side`}>
							<button className={`button-normal`} onClick={(e) => setSelectedTab('themes')}>back</button>
						</div>
						<div className={`right-side`}>
							<button className={`button-normal`} onClick={(e) => {
								showAlertDialog(
									"Confirm Submit",
									"Are you sure you want to submit this changes?",
									handlePolicesFinishClick,
									undefined
								)
							}}>
								{isUpdate ? "Update" : "Add"}
							</button>
							{isUpdate && (
								<button style={{ backgroundColor: "var(--color-main-red)" }} className={`button-normal`} onClick={(e) =>
									showAlertDialog(
										"Confirm Delete",
										"Are you sure you want to delete this user?",
										handleDeleteUser,
										undefined
									) 
								}>Delete</button>
							)}
						</div>
					</div>
				</div>
			</div>
			{isLoading ? <LoadingScreen /> : null}
			{alertDialogState && (
            	<AlertDialog
                title={alertTitle}
                description={alertDescription}
                windowState={alertDialogState}
                setWindowState={setAlertDialogState}
                function={alertYesCallback}
                okFunction={alertOkCallback}
            />
            )}
		</div>
	);
};

export default OrganizationAddUser;